import { useState } from "react";
import { ChevronDown } from "lucide-react";

export const Faq = ({ items = [], title, testid = "faq" }) => {
  const [open, setOpen] = useState(0);
  if (!items.length) return null;
  return (
    <section data-testid={testid} className="max-w-3xl">
      {title ? <h2 className="font-display text-2xl lg:text-3xl text-ink mb-8">{title}</h2> : null}
      <div className="border-t border-brass-light">
        {items.map((item, i) => (
          <div key={item.q} className="border-b border-brass-light">
            <button
              data-testid={`${testid}-q-${i}`}
              onClick={() => setOpen(open === i ? -1 : i)}
              className="w-full flex items-center justify-between gap-6 py-5 text-start"
            >
              <span className="text-base text-ink">{item.q}</span>
              <ChevronDown size={17} className={`text-brass shrink-0 transition-transform duration-300 ${open === i ? "rotate-180" : ""}`} />
            </button>
            {open === i ? <p className="pb-6 text-sm text-muted leading-relaxed max-w-2xl">{item.a}</p> : null}
          </div>
        ))}
      </div>
    </section>
  );
};

export default Faq;
